import * as url from "../../helpers/url_helper";
import { apiCall } from "./apiService";

/**
 * Loads scanner websites from API
 * @param {Function} notifyError - Error notification function
 * @returns {Promise<Array|null>} Scanner websites data or null if error
 */
export const loadScannerWebsites = async (notifyError) => {
    const results = await apiCall(
        url.COUPON_SCANNER_WEBSITE,
        'GET',
        null,
        notifyError,
        "Failed to load scanner websites"
    );

    if (!results) return null;

    const scannerWebsiteData = Array.isArray(results) ? results : (results?.data || []);
    return scannerWebsiteData.map(({ id, name }) => ({ id, name }));
};

/**
 * Loads coupon scanner data for a store
 * @param {string} store - Store name
 * @param {Function} notifyError - Error notification function
 * @returns {Promise<Array|null>} Coupon scanner data or null if error
 */
export const loadCouponScannerData = async (store, notifyError) => {
    const results = await apiCall(
        `${url.COUPON_SCANNER}?store=${store}`,
        'GET',
        null,
        notifyError,
        "Failed to load coupon scanner data"
    );

    if (!results) return null;

    return Array.isArray(results) ? results : (results?.data || []);
};

/**
 * Loads store handle (Auto BCL) data
 * @param {string} store - Store name
 * @param {Function} notifyError - Error notification function
 * @returns {Promise<Object|null>} Store handle data or null if error
 */
export const loadStoreHandle = async (store, notifyError) => {
    const results = await apiCall(
        `${url.AUTO_BCL}/single?store=${store}`,
        'GET',
        null,
        notifyError,
        "Failed to load store handle"
    );

    if (!results) return null;

    return results?.data || results || {};
};

/**
 * Loads merchant info for a store
 * @param {string} store - Store name
 * @param {Function} notifyError - Error notification function
 * @returns {Promise<Object|null>} Merchant info data or null if error
 */
export const loadMerchantInfo = async (store, notifyError) => {
    const results = await apiCall(
        `${url.MERCHANT_INFO}?store=${store}`,
        'GET',
        null,
        notifyError,
        "Failed to load merchant info"
    );

    if (!results) return null;

    return results?.data || results || {};
};

/**
 * Updates a coupon scanner entry
 * @param {Object} params - Update parameters
 * @param {string} params.store - Store name
 * @param {string} params.scannerWebsite - Scanner website ID
 * @param {string} params.siteUrl - Site URL
 * @param {string} params.coupons - Coupons data
 * @param {Array} params.websiteUrls - Website URLs array
 * @param {Function} notifyError - Error notification function
 * @returns {Promise<Object|null>} Response data or null if error
 */
export const updateCouponScanner = async ({ store, scannerWebsite, siteUrl, coupons, websiteUrls }, notifyError) => {
    return await apiCall(
        url.COUPON_SCANNER,
        'PUT',
        {
            store,
            site_url: siteUrl,
            scanner_website: scannerWebsite,
            coupons,
            website_urls: websiteUrls,
        },
        notifyError,
        "Error updating coupon scanner"
    );
};

/**
 * Updates custom params for a store
 * @param {string} id - Store handle ID
 * @param {Object} customParams - Custom parameters (domain, handle, query)
 * @param {Function} notifyError - Error notification function
 * @returns {Promise<Object|null>} Response data or null if error
 */
// export const updateCustomParams = async (id, customParams, notifyError) => {
//     if (!id) return null;

//     return await apiCall(
//         url.CUSTOM_PARAMS,
//         'PUT',
//         { id, custom_params: customParams },
//         notifyError,
//         "Failed to update custom params"
//     );
// };

/**
 * Generates coupon scanner links
 * @param {string} domain - Domain name
 * @param {string} handle - Handle
 * @param {string} query - Query parameter
 * @param {Function} notifyError - Error notification function
 * @returns {Promise<Object|null>} Generated links data or null if error
 */
export const generateLinks = async (domain, handle, query, notifyError) => {
    const results = await apiCall(
        `${url.GENERATE_LINKS}?domain=${domain}&handle=${handle}&query=${query}`,
        'GET',
        null,
        notifyError,
        "Error generating links"
    );

    if (!results) {
        return null;
    }

    console.log(results)
    return results;
};

/**
 * Creates multiple coupon scanner entries
 * @param {Array} scannerCoupon - Array of scanner coupon objects
 * @param {Function} notifyError - Error notification function
 * @returns {Promise<Object|null>} Response data or null if error
 */
export const createMultipleCouponScanner = async (scannerCoupon, notifyError) => {
    if (!scannerCoupon || scannerCoupon.length === 0) return null;

    return await apiCall(
        url.MULTIPLE_COUPON_SCANNER,
        'POST',
        { scanner_coupon: scannerCoupon },
        notifyError,
        "Failed to create coupon scanner entries"
    );
};

